function setCookie(name, value, days=365, secure=true){
    const maxAge = days * 24 * 60 * 60;
    const encodedValue = encodeURIComponent(value);
    const secureFlag = secure ? '; secure' : '';

    document.cookie = `${name}=${encodedValue}; max-age=${maxAge}; path=/; samesite=strict${secureFlag}`;
}
function getCookie(name) {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.indexOf(cookieName) === 0) {
            const decodeValue = cookie.substring(cookieName.length);
            return decodeURIComponent(decodeValue);
        }
    }
    return false;
}

function deleteCookie(name) {
    document.cookie = `${name}=; max-age=0; path=/; samesite=strict`;
}

function handleAside(initial = false) {
    var asideMenuVisibility = getCookie("aside-menu-visible") || false;
    var asideWidth = $('.aside-menu').innerWidth() || 0;
    var $main = $('main.container-fluid');
    var $aside = $('.aside-menu');
    var $toggleShow = $aside.find('.toggleShow');
    if (asideMenuVisibility === "true") {
        $aside.addClass('visible');
        $toggleShow.addClass('active');
        if (initial) {
            const mainTransition = $main.css('transition');
            const asideTransition = $aside.css('transition');
            const toggleShowTransition = $toggleShow.css('transition');

            $main.css('transition', 'none');
            $aside.css('transition', 'none');
            $toggleShow.css('transition', 'none');

            $main.css({
                paddingRight: `${asideWidth + 20}px`
            }).addClass("sidebar-active");
            $aside.css({ right: 0 });

            setTimeout(() => {
                $main.css('transition', mainTransition);
                $aside.css('transition', asideTransition);
                $toggleShow.css('transition', toggleShowTransition);
            }, 0);
        } else {
            $main.animate({
                paddingRight: `${asideWidth + 20}px`,
            }, 300).addClass("sidebar-active");
        }
    }
}


function updateAsidePosition(row,stickyThreshold=20) {
    if (!$(".aside-menu").length) return;
    const rowOffsetTop = row.offset().top;
    const scrollTop = $(window).scrollTop();
    const toolbar = $(".toolbar");
    // $(".aside-menu").css({
    //     position: "fixed",
    //     top: `${rowOffsetTop + 20}px`,
    // });

    if (scrollTop >= rowOffsetTop - stickyThreshold) {
        $(".aside-menu").css({
            position: "fixed",
            top: `${stickyThreshold}px`,
        });
    } else {
        $(".aside-menu").css({
            position: "fixed",
            // top: `${rowOffsetTop + 65}px`,
        });
    }
}
$(document).ready(function () {
    $('.aside-menu').on('click', '.toggleShow', function (e) {
        e.preventDefault();
        var asideWidth = $(this).closest('.aside-menu').innerWidth();
        $(this).toggleClass('active');
        var $aside = $(this).closest('.aside-menu');
        if ($(this).hasClass('active')) {
            setCookie("aside-menu-visible", "true");
            $('main.container-fluid').animate({
                paddingRight: `${asideWidth + 20}px`,
            }, 300).addClass("sidebar-active");
            $aside.addClass('visible');
        } else {
            deleteCookie("aside-menu-visible");
            $('main.container-fluid').animate({
                paddingRight: "20px",
                display: "unset",
            }, 300).addClass("sidebar-active");
            $aside.removeClass('visible');
            $aside.css({right: ''});
        }
    }).on('click', '.toggleHide', function (e) {
        e.preventDefault();
        $('main.container-fluid').animate({
            paddingRight: "20px",
            display: "unset",
        }, 300).removeClass("sidebar-active")
        deleteCookie("aside-menu-visible");
        $('.toggleShow').removeClass('active');
        var $aside = $(this).closest('.aside-menu');
        $aside.removeClass('visible');
        $aside.css({right: ''});
    });
    if ($(".aside-menu").length) {
        $(window).on("scroll", function () {
            updateAsidePosition($(".row"), 100);
        });
    }
    $('.aside-menu ul.menu a').each(function () {
        const el = this;
        if (el._tooltipInstance) {
            el._tooltipInstance.dispose();
            el._tooltipInstance = null;
        }
        if (el.scrollWidth > el.clientWidth) {
            el.setAttribute('data-bs-toggle', 'tooltip');
            el.setAttribute('data-bs-placement', 'left');
            el.setAttribute('title', el.textContent.trim());

            if (typeof bootstrap !== "undefined" && bootstrap.Tooltip && el.length > 0) {
                el._tooltipInstance = new bootstrap.Tooltip(el);
            }
        } else {
            el.removeAttribute('data-bs-toggle');
            el.removeAttribute('data-bs-placement');
            el.removeAttribute('title');
            if (el._tooltipInstance) {
                el._tooltipInstance.dispose();
                el._tooltipInstance = null;
            }
        }
    });
    handleAside(true);
    updateAsidePosition($(".row"));
});
